// Pace-based risk coloring for allowance usage bars.
//
// Raw "% of allowance used" alone doesn't tell you whether you're on track — 65%
// used with 90% of the period elapsed is fine, but 65% used with only 30% of the
// period elapsed means you're burning allowance much faster than time is passing.
//
// projectedPct = (pctUsed / pctElapsed) * 100 answers "at this pace, what % will I
// have used by the time the period resets?" — the same idea cloud billing alerts
// (AWS/GCP budget alarms) use for burn-rate projections.
const GREEN_MAX = 90;
const AMBER_MAX = 110;

// Guard against unstable projections right at the start of a period (e.g. day 1 —
// dividing by a tiny elapsed% blows the projection up arbitrarily). Below this
// threshold, judge risk on raw pctUsed instead of the projection.
const MIN_PCT_ELAPSED_FOR_PROJECTION = 5;

export const RISK_COLORS = {
  green: "#25C469",
  amber: "#FAB219",
  red: "#FC8181",
};

/**
 * @param {number} pctUsed - usage as a % of the allowance (0-100+)
 * @param {number} daysElapsed
 * @param {number} daysToReset
 * @returns {{ projectedPct: number, risk: "green" | "amber" | "red", color: string }}
 */
export function getAllowancePace(pctUsed, daysElapsed, daysToReset) {
  const totalDays = daysElapsed + daysToReset;
  const pctElapsed = totalDays > 0 ? (daysElapsed / totalDays) * 100 : 100;

  const projectedPct = pctElapsed >= MIN_PCT_ELAPSED_FOR_PROJECTION ? (pctUsed / pctElapsed) * 100 : pctUsed;

  let risk = "green";
  if (projectedPct > AMBER_MAX) {
    risk = "red";
  } else if (projectedPct > GREEN_MAX) {
    risk = "amber";
  }

  return { projectedPct, risk, color: RISK_COLORS[risk] };
}
